import { defineStore } from 'pinia'
import axios from 'axios'

// const baseURL = 'http://127.0.0.1:5000/'
// baseURL = 'http://192.168.1.177:5000/',
// const baseURL = '/api/'
const baseURL = 'https://lycp.fr/api'
let reqInstance = axios.create({
    baseURL: baseURL
})

// let reqInstanceUrlEncoded = axios.create({
//   baseURL: 'https://lycp.fr/api',
//   // headers: {'Content-Type': 'application/x-www-form-urlencoded'}
// })

async function call (axiosInstance, method, url, data) {
  // async function call (method: string, url: string, data?: any, params?: any, successMsg?: string, errorMsg?: string, loader?: boolean) {
    return await axiosInstance
      .request({ method, url, data })
      .then((response) => {
        return { 'data': response.data, 'status': true }
      })
      .catch((error) => {
        console.log(`Caught error : ${error}`)
        return { 'data': null, 'status': false }
      })
}

export const useApiStore = defineStore('api', {
  state: () => ({
    axiosInstance: reqInstance
  }),
  actions: {
    async get(url, data) {
      return await call(this.axiosInstance,'GET', url=url, data=data)
    },
    async post(url, data) {
      return await call(this.axiosInstance,'POST', url=url, data=data)
    },
    async delete(url, data) {
      return await call(this.axiosInstance,'DELETE', url=url, data=data)
    },
    async put(url, data) {
      return await call(this.axiosInstance,'PUT', url=url, data=data)
    },
    addToken () {
      this.axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`
    },
    useUrlEncoded () {
      // this.axiosInstance = reqInstanceUrlEncoded
      this.axiosInstance.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
      // this.axiosInstance = reqInstanceUrlEncoded
    },
    useDefaultInstance () {
      // this.axiosInstance = reqInstance
      delete this.axiosInstance.defaults.headers.common['Content-Type']
    }

  },
})